import styled from '@emotion/styled'
import { Heading, MediaQueries } from '@hhgtech/hhg-components'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import Link from 'next/link'
import { useIntl } from 'react-intl'

import { Container } from 'components/atoms/container'
import { domainLocales } from 'domainLocales'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath } from 'interfaces/constants'

const Styled404 = styled.div`
  .notFoundGrid {
    padding: 0 16px;
    margin: 64px auto 64px auto;
    button {
      border: 0;
      margin-top: 16px;
    }

    ${MediaQueries.mbUp} {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      margin: 128px auto 128px auto;
      height: calc(100vh - 365px);
    }

    ${MediaQueries.mbDown} {
      text-align: center;
    }

    .content {
      ${MediaQueries.mbDown} {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      h2 {
        margin-bottom: 16px;
        ${MediaQueries.mbDown} {
          margin-top: 16px;
          text-align: center;
        }
      }
      p {
        max-width: 400px;
      }
    }
  }
`

const NotFound = () => {
  const isMobile = useIsMobile()
  const { formatMessage: f } = useIntl()
  const { locale } = useRouterExtend()
  // const allTools = STATIC_PAGES[locale || defaultLocale] || {}

  const domain = domainLocales[locale]

  const emailAddress = 'admin@' + domain

  return (
    <Styled404>
      {/* <TopBar
  type="home"
  isMobile={isMobile}
  onMenuClick={() => router.push('/')}
  searchPlaceholder={f({
    id: 'home.search',
    defaultMessage: 'Search',
  })}
  isSearchBarDisplay={false}
/> */}

      <Container className="notFoundGrid">
        <img
          alt=""
          src={`${assetImagePath}/notFound.jpg?v=1`}
          style={{
            width: isMobile ? '100%' : '568px',
            height: isMobile ? '100%' : '319px',
          }}
          loading="lazy"
        />
        <div className="content">
          <Heading tag="h2">
            {' '}
            {f({
              id: '404.pageNotFound',
              defaultMessage: 'Sorry, this page cannot be found',
            })}
          </Heading>
          <Text size="p3">
            <span
              dangerouslySetInnerHTML={{
                __html: f(
                  {
                    id: '404.explainer',
                    defaultMessage:
                      'If you clicked a link that led to this page, please let us know so we can fix our mistake as soon as possible.',
                  },
                  {
                    email: `<a href="mailto:${emailAddress}">${emailAddress}</a>`,
                  },
                ),
              }}
            />
          </Text>
          <Link prefetch={false} href="/" style={{ textDecoration: 'none' }}>
            <Button size="md">
              {f({
                id: '404.goBackHome',
                defaultMessage: 'Go Back Home',
              })}
            </Button>
          </Link>
        </div>
      </Container>
    </Styled404>
  )
}

export { NotFound }
